import axios from "axios";
import { config } from "../constant";
import { LocalStorage } from "../custom_hooks/localStorageKeys";
import { GetItemFromStorage } from "../custom_hooks/useStorage";

export class ApiServices {
  public static async get(endPoint: any) {
    // const accessToken = await GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().BASE_URL;
    return axios
      .get(`${url}${endPoint}`, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: "",
          'Content-Type': 'application/json'
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static async post(data: any, endPoint: any) {
    const url: any = config().BASE_URL;
    // const accessToken = await GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    return axios
      .post(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: "",
          'Content-Type': 'application/json'
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static async put(data: any, endPoint: any) {
    // const accessToken = await GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().BASE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: "",
          'Content-Type': 'application/json'
        },
      })
      .then((response: any) => {
          return response;
      });
  }

  public static async patch(data: any, endPoint: any) {
    // const accessToken = await GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().BASE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: "",
          'Content-Type': 'application/json'
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static async delete(data: any, endPoint: any) {
    // const accessToken = await GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().BASE_URL;
    return axios
      .put(`${url}${endPoint}`, data, {
        headers: {
          appId: config().APPID,
          appSecret: config().AppSECRET,
          Authorization: "",
          'Content-Type': 'application/json'
        },
      })
      .then((response: any) => {
        return response;
      });
  }

  public static async fileUpload(data: any, endPoint: any) {
    // const accessToken = await GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
    const url: any = config().BASE_URL;
    return axios.post(`https://cvm-api.worktual.co.uk/cvm_api_service/v1${endPoint}`, data, {
      headers: {
          'Content-Type': 'multipart/form-data',
      },
  });
  }
}